import React, { FC } from 'react';
import { Box, Text, Button, ButtonAppearance } from '@bechtel/gds';
import { Modal, ModalBody, ModalFooter } from '@bechtel/gds';
import { ModalHeaderStyled } from '~/components';
import { t, Trans } from '@lingui/macro';
import { FileUploadCustomErrorProps, FileUploadError } from './types';

const getErrorMessage = (
  error: FileUploadCustomErrorProps['error'],
  maxFileSizeMB: FileUploadCustomErrorProps['maxFileSizeMB']
) => {
  switch (error) {
    case FileUploadError.EXCEED_MAX_FILE_LIMIT:
      return <Trans>Only select 1 file at a time.</Trans>;
    case FileUploadError.EXCEED_MAX_FILE_SIZE_LIMIT:
      return <>{t`File size should not be greater than ${maxFileSizeMB} MB`}</>;
    case FileUploadError.FILE_TYPE_NOT_SUPPORTED:
      return <Trans>File type not supported. </Trans>;
    case FileUploadError.REQUEST_TIMED_OUT:
      return <Trans>An error has occurred. Please check your connectivity and try again.</Trans>;
    default:
      return <Trans>An error has occurred. Please try again after sometime or contact system administrator. </Trans>;
  }
};

export const FileUploadCustomError: FC<FileUploadCustomErrorProps> = ({ error, close, maxFileSizeMB }) => {
  return (
    <Modal visible>
      <ModalHeaderStyled title={t`Document/Photo upload error`}></ModalHeaderStyled>
      <ModalBody>
        <Box px={{ sm: '500' }} py={{ sm: '700' }}>
          <Text size="600">{getErrorMessage(error, maxFileSizeMB)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
